import React, { useEffect, useState } from 'react'
import { useFormik } from "formik"
import Select from "react-select";
import * as Yup from "yup"
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import useApi from 'common/ApiMiddlewere'
import toast from 'react-hot-toast'
import Flatpickr from "react-flatpickr";
import { dateFormat, dateTimeFormat, dateTimeFormatIOS, formatDateToISO } from 'pages/Common';
import Dropzone from "react-dropzone"
import Compressor from "compressorjs"
import uploadImage from "../../assets/images/uploadImage.png"


const colourStyles = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        return {
            ...styles,
            border: "1px solid #ced4da",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
            backgroundColor: isDisabled ? "#e9ecef" : "#fff",
            color: isDisabled ? "#6c757d" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            pointerEvents: isDisabled ? "none" : "auto",  // Important for full disabling
            opacity: isDisabled ? 0.6 : 1,
        };
    },
}

const UpdateFabricModel = ({ modal, toggle, isEdit, editData, FabricListApi, AssignByData, userData }) => {
    const { deleteApi, getApi, postApi, putApi } = useApi()
    const [isMobile, setisMobile] = useState(window.innerWidth < 924)
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [date, setdate] = useState(editData ? dateFormat(
        editData?.Date.split("T")[0],
        "dd-MM-yyyy"
    ) : dateFormat(
        new Date(),
        "dd-MM-yyyy"
    ))
    const [previewUrl, setPreviewUrl] = useState('')
    const [userFilter, setUserFilter] = useState(0)
    useEffect(() => {
        if (editData && isEdit) {
            setPreviewUrl(editData?.Image)
            setdate(editData ? dateFormat(
                editData?.Date.split("T")[0],
                "dd-MM-yyyy"
            ) : dateFormat(
                new Date(),
                "dd-MM-yyyy"
            ))
        } else {
            setPreviewUrl('')
            setdate(dateFormat(new Date(), "dd-MM-yyyy"))
            setUserFilter(0)
        }
    }, [editData])

    const handleKeyPress = event => {
        const charCode = event.which || event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    };

    // Requirement Validations
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            OrderNo: editData ? editData.OrderNo : '',
            Name: editData ? editData.CreatedByName : '',
            Stuff: editData ? editData?.Stuff : '',
            profilePic: "",
        },
        validationSchema: Yup.object({
            OrderNo: Yup.string().required("The Sr. No. is required"),
        }),
        onSubmit: values => {

            if (!isEdit && userFilter == 0) {
                toast.error("Please select a designer", {
                    style: {
                        fontSize: "15px",
                    },
                })
                return true
            }
            setformSumitLoading(true)
            if (values) {
                const profilePic =
                    (values.profilePic == "" || values.profilePic == undefined)
                        ? previewUrl
                        : values.profilePic.split(",")[1]

                if (isEdit) {
                    putApi("Fabric/update", {
                        Id: editData.Id,
                        OrderNo: values.OrderNo,
                        Date: formatDateToISO(date),
                        Stuff: values.Stuff || '',
                        Image: profilePic || '',
                    }).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status == 400) {
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            toast.success("Sucessfully updated", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            toggle()
                            setdate(new Date())
                            if (FabricListApi != '') {
                                FabricListApi()
                            }
                            validation.handleReset()
                        }
                    })
                } else {
                    postApi("Fabric/create", [{
                        designerBy: userFilter?.value,
                        OrderNo: values.OrderNo,
                        Date: formatDateToISO(date),
                        Stuff: values.Stuff || '',
                        Image: profilePic,
                    }]).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status = 200) {
                            toast.success("Successfully Created", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            toggle()
                            setdate(new Date())
                            if (FabricListApi != '') {
                                FabricListApi()
                            }
                            validation.handleReset()
                        } else {
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        }
                    })
                }
            }
        },
    })

    const toBase64 = file =>
        new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => resolve(reader.result)
            reader.onerror = error => reject(error)
        })

    const handleDrop = acceptedFiles => {
        const selectedFile = acceptedFiles[0]
        new Compressor(selectedFile, {
            quality: 0.4, // 0.6 can also be used, but its not recommended to go below.
            success: async compressedResult => {
                setPreviewUrl(URL.createObjectURL(compressedResult))
                validation.setFieldValue("profilePic", await toBase64(compressedResult))
            },
        })
    }


    return (
        <Modal
            isOpen={modal}
            toggle={toggle}
            centered={true}
            size="xl"
            style={{ width: !isMobile ? "500px" : "" }}
        >
            <div className="modal-content">
                <ModalHeader toggle={toggle} tag="h5">
                    {isEdit ? "Update Requirement" : "Create Requirement"}
                </ModalHeader>
                <ModalBody>
                    <Form
                        onSubmit={e => {
                            e.preventDefault()
                            validation.handleSubmit()
                            return false
                        }}
                        onReset={e => {
                            e.preventDefault
                            validation.handleReset()
                            return false
                        }}
                    >
                        <Row>
                            <Col md={4}>
                                <FormGroup className="mb-2">
                                    <Label
                                        htmlFor="validationCustom03"
                                        className="required"
                                    >
                                        Sr. No.
                                    </Label>
                                    <Input
                                        name="OrderNo"
                                        placeholder="Sr. No"
                                        type="text"
                                        className="form-control-sm"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.OrderNo}
                                        invalid={
                                            validation.touched.OrderNo && validation.errors.OrderNo
                                                ? true
                                                : false
                                        }
                                    />
                                    {validation.touched.OrderNo && validation.errors.OrderNo ? (
                                        <FormFeedback type="invalid">
                                            {validation.errors.OrderNo}
                                        </FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>
                            <Col md={8}>
                                {isEdit ?
                                    <FormGroup className="mb-2">
                                        <Label htmlFor="validationCustom03" className="required">
                                            Designer
                                        </Label>
                                        <Input
                                            name="Name"
                                            disabled
                                            placeholder="Designer Name"
                                            type="text"
                                            className="form-control-sm"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.Name}
                                            invalid={
                                                validation.touched.Name && validation.errors.Name
                                                    ? true
                                                    : false
                                            }
                                        />
                                        {validation.touched.Name && validation.errors.Name ? (
                                            <FormFeedback type="invalid">
                                                {validation.errors.Name}
                                            </FormFeedback>
                                        ) : null}
                                    </FormGroup>
                                    :
                                    <FormGroup className="mb-2">
                                        <Label htmlFor="validationCustom03" className="required">
                                            Designer
                                        </Label>
                                        <Select
                                            unstyled
                                            styles={colourStyles}
                                            value={userFilter}
                                            onChange={(e) => setUserFilter(e)}
                                            options={userData}
                                            className="select2-selection"
                                        />
                                    </FormGroup>
                                }
                            </Col>
                        </Row>
                        <Row>
                            <Col md={8}>
                                <FormGroup className="mb-2">
                                    <Label
                                        htmlFor="validationCustom03"
                                        className=''
                                    >
                                        Stuff
                                    </Label>
                                    <Input
                                        name="Stuff"
                                        placeholder="Stuff"
                                        type="textarea"
                                        row={3}
                                        className="form-control-sm"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.Stuff}
                                        invalid={
                                            validation.touched.Stuff && validation.errors.Stuff
                                                ? true
                                                : false
                                        }
                                    />
                                    {validation.touched.Stuff && validation.errors.Stuff ? (
                                        <FormFeedback type="invalid">
                                            {validation.errors.Stuff}
                                        </FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup className="mb-2">
                                    <div>
                                        <Label htmlFor="FollowupValidation1Custom01" className="required">
                                            Date
                                        </Label>
                                        <div className="d-flex date-after" >
                                            <Flatpickr
                                                className="form-control d-block flatpicker-date"
                                                placeholder="dd-MM-yyyy"
                                                options={{
                                                    // enableTime: true,
                                                    dateFormat: "d-m-Y",
                                                    disableMobile: true
                                                }}
                                                value={date}
                                                onChange={(e) => { setdate(e) }}
                                            />
                                        </div>
                                    </div>
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <FormGroup>
                                <Dropzone
                                    onDrop={handleDrop}
                                    onClick={handleDrop}
                                    accept="image/*"
                                    multiple={false}
                                    id="profilePic"
                                    name="profilePic"
                                >
                                    {({ getRootProps, getInputProps }) => (
                                        <>
                                            <div className="d-flex flex-column align-items-center text-center p-2 py-3">
                                                {previewUrl ? (
                                                    <>
                                                        <div className="position-relative overflow-hidden product-image">
                                                            <input {...getInputProps()} />
                                                            <img
                                                                style={{
                                                                    cursor: "pointer",
                                                                    border: "1px solid #ced4da",
                                                                    borderRadius: "3px",
                                                                }}
                                                                width="175px"
                                                                height="200px"
                                                                src={previewUrl}
                                                                {...getRootProps()}
                                                            />
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <input {...getInputProps()} />

                                                        <div
                                                            style={{
                                                                width: "175px",
                                                                height: "200px",
                                                                border: "1px solid #ced4da",
                                                                cursor: "pointer",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                borderRadius: "3px",
                                                            }}
                                                        >
                                                            <img
                                                                className="img-fluid"
                                                                style={{}}
                                                                src={uploadImage}
                                                                {...getRootProps()}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                                {validation.touched.profilePic && validation.errors.profilePic ? (
                                                    <FormFeedback type="invalid">
                                                        {validation.errors.profilePic}
                                                    </FormFeedback>
                                                ) : null}
                                            </div>
                                        </>
                                    )}
                                </Dropzone>
                            </FormGroup>
                        </Row>

                        <div className="text-end">
                            <Button
                                task-title="secondary"
                                className="btn btn-primary me-2 btn-sm "
                                // type="reset"
                                onClick={() => toggle()}
                                color="secondary"
                            >
                                Cancel
                            </Button>
                            {formSumitLoading ? (
                                <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                >
                                    <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                    Loading
                                </button>
                            ) : (
                                <Button
                                    color="primary"
                                    task-title="primary"
                                    className="btn btn-primary btn-sm "
                                    type="submit"
                                >
                                    Submit
                                </Button>
                            )}
                        </div>
                    </Form>
                </ModalBody>
            </div>
        </Modal >
    )
}

export default UpdateFabricModel